
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class DocumentFormatMasterGrid extends Serenity.EntityGrid<DocumentFormatMasterRow, any> {
        protected getColumnsKey() { return 'OMS.DocumentFormatMaster'; }
        protected getDialogType() { return DocumentFormatMasterDialog; }
        protected getIdProperty() { return DocumentFormatMasterRow.idProperty; }
        protected getInsertPermission() { return DocumentFormatMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return DocumentFormatMasterRow.localTextPrefix; }
        protected getService() { return DocumentFormatMasterService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}